import React, { useEffect } from 'react'
import Head from 'next/head'
import JumpstartFocusPage from 'pages/website/LandingPage/EntrepreneurSeminar/FocusPage/JumpstartFocusPage'
import content from 'pages/website/LandingPage/EntrepreneurSeminar/FocusPage/content/raisingInvestment'
import useJumpstartIntake from 'pages/website/LandingPage/EntrepreneurSeminar/useJumpstartIntake'
import { trackAmplitude } from 'services/amplitude/amplitude'
import CommonHead from '../_head'

/**
 * Paid-social landing page for the raising investment pain point, sold as the 7-day free trial since 2 November
 * 2026 (also served at /jumpstart-mw-rf and, with its own source, /jumpstart-mw-ri-trial). Noindex, like
 * /jumpstart-mw: it sells the same product as the home page, and ad traffic arrives by link, not by query.
 *
 * The intake source is the page's path, as on every Jumpstart lander (the pages shared jumpstart-ad until
 * 29 October 2026): the API picks the Brevo list by source, so a new page needs its list configured. The focus
 * the page sells is recorded on the member as jumpstartFocus.
 *
 * @param source  the intake source, for an address that serves this page under its own name
 */
const JumpstartRaisingInvestment = ({ source = 'jumpstart-mw-ri' }) => {
  const onIntakeSubmit = useJumpstartIntake(source, { jumpstartFocus: 'raisingFunds' })

  useEffect(
    () => trackAmplitude('program_viewed', { program_id: 'jumpstart', program_name: 'Jumpstart', page: 'ri' }),
    [],
  )

  return (
    <>
      <Head>
        <title>{content.META.title}</title>
        <meta name="robots" content="noindex, nofollow" />
        <CommonHead description={content.META.description} />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,400..900&family=Rubik:wght@400..800&display=swap"
        />
      </Head>
      <JumpstartFocusPage content={content} onIntakeSubmit={onIntakeSubmit} />
    </>
  )
}

export const getServerSideProps = () => ({ props: { topNavActive: false, footerActive: false } })

export default JumpstartRaisingInvestment
